import React, { useState } from 'react';
import { BedsBathBody } from './BedsBathBody';
import { useClickOutside } from '../../../hooks/useClickOutside';
import { useFilterController } from '../../../../application/useFilterController';

export const BedsBathDropdown = () => {
  const { bedsRange, bathsRange, setBedsRange, setBathsRange, clearBedsAndBaths } = useFilterController();

  const [ open, setOpen ] = useState(false);
  const dropdownRef = useClickOutside<HTMLDivElement>(() => setOpen(false));

  const reset = () => {
    clearBedsAndBaths();
  };

  const formatLabel = () => {
    const beds = bedsRange;
    const baths = bathsRange;

    let bedsLabel = 'Any bd';
    let bathsLabel = 'Any ba';

    // Beds
    if (beds && beds.min != null) {
      const { min, max } = beds;

      if (max == null) {
        // open-ended: e.g. 6+ bd
        bedsLabel = `${min}+ bd`;
      } else if (min === max) {
        bedsLabel = `${min} bd`;
      } else {
        bedsLabel = `${min}-${max} bd`;
      }
    }

    // Baths (min-only)
    if (baths && baths.min != null) {
      const { min } = baths;
      bathsLabel = `${min}+ ba`;
    }

    return `${bedsLabel} / ${bathsLabel}`;
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        onClick={() => setOpen(prev => !prev)}
        className="border rounded px-3 py-2 bg-white text-gray-800 flex items-center justify-between min-w-[160px]"
      >
        <span className="text-sm">{formatLabel()}</span>
        <svg
          className="ml-2 h-4 w-4 text-gray-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.65a.75.75 0 01-1.08 0l-4.25-4.65a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {open && (
        <div className="absolute left-0 mt-2 w-[420px] bg-white border rounded shadow-lg z-10 p-4">
          <BedsBathBody
            bedsRange={bedsRange}
            bathsRange={bathsRange}
            onBedsRangeChange={setBedsRange}
            onBathsRangeChange={setBathsRange}
          />

          <div className="flex justify-between items-center mt-4">
            <button
              onClick={reset}
              className="text-blue-600 text-sm font-medium hover:underline"
            >
              Reset
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
